module.exports = __webpack_public_path__ + "img/video.9831cb75.svg";